<template>

    <!--
        Should be able to make this general by passing the tabs as a prop
        the tabs will be a dictionary with the key being the tab name and the value being the tab label
     -->
    <div>
        <div class="sm:hidden">
            <label class="sr-only" for="tabs">Select a tab</label>
            <select
                    id="tab"
                    class="block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                    name="tabs"
                    @change="updateTab($event.target.value)">
                <option     v-for="(value, key) in deviceSeriesTypes"
                            :selected="$data.selectedTab === key"
                            :value="key">
                    {{ value }}
                </option>
            </select>
        </div>

        <div class="hidden sm:block">
            <div class="border-b border-gray-200">
                <nav aria-label="Tabs" class="-mb-px flex space-x-8">
                    <undecorated-link   v-for="(value, key) in deviceSeriesTypes"
                                        :class="[$data.selectedTab === key ? 'border-blue-600 hover:border-blue-700 text-blue-600 hover:text-blue-700' : 'border-transparent hover:border-gray-300 text-gray-500  hover:text-gray-700']"
                                        class=" whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium"
                                        @click="updateTab(key)">
                        {{ value }}
                    </undecorated-link>
                </nav>
            </div>
        </div>
    </div>

</template>

<script>

import axios from "axios"
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import UndecoratedLink from "@/components/EnterpriseDashboard/undecorated-link.vue";

export default {
    name: "DeviceSeriesSelection",
    mixins: [SonicuCoreMixin, iconNamesMixin],
    components: {UndecoratedLink},
    emits: ['update:currentTab'],
    props: {
        currentTab: {
            type: String,
            default: 'SoniShield'
        }
    },
    data() {
        return {
            deviceSeriesTypes: {
                'sonishield': 'SoniShield / MVP',
                's-series-temperature': 'S-Series Temperature',
                's-series-ht': 'S-Series HT',  // <- Was S-Series key.
                's-series-ht-co2': 'S-Series T/H/CO2',
                's-series-rope-ht': 'S-Series Rope + HT',
                's-series-light': 'S-Series Light',
            },
            selectedTab: this.currentTab,
        }
    },
    created() {

    },
    mounted() {

    },
    methods: {
        updateTab(tab) {
            this.selectedTab = tab;
        }
    },
    computed: {

    },
    watch: {
        currentTab(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.selectedTab = newValue
            }
        },
        selectedTab(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.$emit('update:currentTab', newValue)
            }
        }
    },
}
</script>

<style scoped>

</style>